import type { MinMax } from '../../core/types/min-max.js';
import type { AxisScaleType } from '../../core/types/scales.js';
import { getScale } from '../../core/utils/scale.js';

export const getYScaleForTimeseries = (
  axisBoundaries: MinMax,
  maxRange: number,
  scale: AxisScaleType = 'linear',
) => getScale(scale, axisBoundaries, [maxRange, 0]);
